import React from 'react';
import { connect } from 'react-redux';
import { columnName, columnPermissions, columnSelect } from '@/constants/fields';
import paging from '@/hooks/paging';
import RolesTable from '../components/RolesTable';
import { fetchRoles } from '../actions';

const RoleDefaultRoleTable = ({
  roles,
  readStatus,
  readErrors,
  total,
  currentPage,
  pageSize,
  pageCount,
  fetchData,
}) => {
  paging.useFetchByCategory(fetchData, 'defaultSelection', readStatus);
  return (
    <RolesTable
      className="aridhia-default-role-table"
      columns={[columnSelect, columnName, columnPermissions]}
      category="defaultSelection"
      currentPage={currentPage}
      fetchData={fetchData}
      hideColumns
      hideFlags
      pageCount={pageCount}
      pageSize={pageSize}
      readErrors={readErrors}
      readStatus={readStatus}
      roles={roles}
      selectable
      total={total}
    />
  );
};

const mapStateToProps = ({
  roles: {
    roles: {
      defaultSelection: {
        results, readStatus, readErrors, count, currentPage, pageSize, totalPages,
      },
    },
  },
}) => ({
  roles: results,
  readStatus,
  readErrors,
  total: count,
  currentPage,
  pageSize,
  pageCount: totalPages,
});

const mapDispatchToProps = {
  fetchData: fetchRoles,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleDefaultRoleTable);
